import React from 'react';
import PropTypes from 'prop-types';
import { DraggableModalDialog } from '../DraggableModalDialog';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

function SupportDlg(props) {

    SupportDlg.propTypes = {
        isOpen: PropTypes.bool.isRequired,
        toggleModal: PropTypes.func.isRequired
    }

    return (
        <Modal dialogAs={DraggableModalDialog} show={props.isOpen} onHide={props.toggleModal} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                   Support
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faInfoCircle} color="#4189C7" size="xl" className="me-3 mt-2" />
                    <span>OMDGo was developed by Jemmac Software Ltd under contract to ExxonMobil</span>
                </p>
                <p>
                    <strong>Support is provided by:</strong>
                </p>
                <p>Jemmac Software Ltd</p>
                <p>If you require support please contact us at <a href="mailto:omdgo@jemmac.com" target="blank">omdgo@jemmac.com</a></p>
            </Modal.Body>
            <Modal.Footer>
                <Button color="primary" onClick={props.toggleModal}>OK</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default SupportDlg;